<template>
	<div v-show="hasButton" class="m-doc-handle-place">
		<div ref="button" class="m-doc-handle flex-start-center flex-reverse">
			<template v-if="status == -1 && applicant">
				<c-button size="dialog" color="red" @click="$emit('delete')">删除</c-button>
				<c-button size="dialog" @click="$emit('edit')">编辑</c-button>
			</template>

			<template v-if="status == 1 && approver">
				<c-button size="dialog" color="main" @click="approveHandle">审批</c-button>
				<c-button size="dialog" color="red" @click="rejectHandle">驳回</c-button>
			</template>

			<template v-else-if="status == 1 && applicant">
				<c-button size="dialog" @click="cancelHandle">撤销</c-button>
			</template>

			<template v-else-if="(status == 3 || status == 4) && applicant">
				<c-button size="dialog" color="main" @click="$emit('restart')">重新发起</c-button>
			</template>
			
			<slot></slot>
		</div>

		<c-dialog ref="approve" title="审批" width="450">
			<c-form ref="approveForm" vertical unit-width="100%">
				<c-form-item label="选择审批人">
					<c-select name="employeeId" :options="approverList" :clear="false"></c-select>
				</c-form-item>

				<c-form-item label="选择抄送人">
					<c-select name="copyEmpId" multiple async @search="searchMember"></c-select>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="reject" title="驳回" width="550">
			<div style="padding: 20px 30px;">
				<c-input v-model="remark" type="textarea" placeholder="请填写驳回原因" :height-resize="false" style="height: 140px;"></c-input>
			</div>
		</c-dialog>
	</div>
</template>

<script>
	export default {
		name: 'docHandle',

		props: {
			order: [String, Number],
			flow: [String, Number],
			status: [String, Number],
			applicant: Boolean,
			approver: Boolean
		},
		
		data() {
			return {
				hasButton: false,
				approverList: [],
				remark: ''
			}
		},

		mounted() {
			this.updatedHandle();
		},

		updated() {
			this.updatedHandle();
		},

		beforeDestroy() {
			clearTimeout(this._timer);
		},

		methods: {
			init(data) {
				this._transaction = data;
				let $base = this.$parent.$children.find(item => item.$options.name == 'docBase');
				$base && this.$nextTick(() => {
					$base.status = this.status;
				});
			},

			updatedHandle() {
				this.$nextTick(() => {
					this.hasButton = this.$refs.button.children.length > 0;
				});
			},

			searchMember(keyword, resolve) {
				this.request({
					url: '/sys_user/mini/select_list',
					data: {
						view_model: 2,
						keyword: keyword.trim()
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.user_realname,
								value: item.id
							}
						}));
					}
				});
			},

			approveHandle() {
				new Promise(resolve => {
					if (!this._transaction.approver || !this._transaction.approver.length) {
						this.$confirm({
							message: '确定要审核通过吗？',
							resolve
						});
					} else {
						this.approverList = this._transaction.approver.map(item => {
							return {
								name: item.name,
								value: item.id
							}
						});

						this.$refs.approveForm.clear();
						this.$refs.approveForm.set({
							employeeId: this.approverList[0].value
						});

						this.$refs.approve.open({
							resolve: (stop, next) => {
								stop();
								this.$refs.approveForm.validate({
									rule: {
										employeeId: '请选择审批人'
									},
									success: data => {
										data.copyEmpId = data.copyEmpId ? data.copyEmpId.join(',') : '';
										next();
										resolve(data);
									}
								});
							}
						});
					}
				}).then((data = {}) => {
					this.request({
						url: '/flow/transaction/approve',
						data: Object.assign({
							executeState: 1,
							formId: this._transaction.formId,
							restart: this._transaction.restart
						}, data),
						loading: true,
						success: () => {
							this.$message({
								message: '审批成功'
							});
							this.updateHandle();
						}
					});
				});
			},

			rejectHandle() {
				this.remark = '';
				this.$refs.reject.open({
					resolve: (stop, next) => {
						stop();
						if (!this.remark) {
							this.$message({
								message: '请填写驳回原因'
							})
							return;
						}
						this.request({
							url: '/flow/transaction/approve',
							data: {
								executeState: 9,
								formId: this._transaction.formId,
								remark: this.remark
							},
							loading: true,
							success: () => {
								next();
								this.$message({
									message: '驳回成功'
								});
								this.updateHandle();
							}
						});
					}
				});
			},

			cancelHandle() {
				this.$confirm({
					message: '确定要撤销该单据吗',
					resolve: () => {
						this.request({
							url: '/workflow/order/withdraw',
							data: {
								order_type: this.flow,
								order_id: this.order
							},
							loading: true,
							success: () => {
								this.$message({
									message: '撤销成功'
								});
								this.updateHandle();
							}
						});
					}
				});
			},

			updateHandle() {
				// 参照移动端：先立即刷新详情，2 秒后再刷新详情与流程（后端异步处理）
				this.$emit('update');
				this._timer = setTimeout(() => {
					this.$emit('update');
					let $log = this.$parent.$children.find(item => item.$options.name == 'docLog');
					$log && $log.update();
				}, 2000);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-handle {
		gap: 12px;
		z-index: 90;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 60px;
    	border-top: 1px solid var(--unit-line);
		padding: 0 20px;
		background: #fff;

		&-place {
			min-height: 61px;
		}
	}
</style>
